module.exports = __webpack_public_path__ + "resources/img/ico_termselect_arrow_v2.51b55529596ffaeeb51c603dcd3796cb.svg";